<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="event_list" sort-by="name" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Event Master</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Event</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <!-- Event Name -->
                                                <!-- <v-col cols="12" sm="4" md="4">
                                                    <b>Event Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field label="Slot Name" v-model="slotName" outlined
                                                        dense></v-text-field>
                                                </v-col> -->
                                                <v-col cols="12" sm="12" md="12">
                                                    <b>Event Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="name" :persistent-hint="editedIndex !== -1"
                                                        dense :rules="[v => !!v || 'Event Name is required']"
                                                        hint="For ex. PTM-Dec-2024..." outlined></v-text-field>
                                                </v-col>

                                                <!-- From Date -->

                                                <v-col cols="12" sm="12" md="12">
                                                    <b>From Date</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-datetime-picker v-model="from_date_time" dateFormat="dd-MM-yyyy"
                                                        outlined></v-datetime-picker>
                                                </v-col>

                                                <!-- To Date -->
                                                <v-col cols="12" sm="12" md="12">
                                                    <b>To Date</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-datetime-picker v-model="to_date_time" dateFormat="dd-MM-yyyy"
                                                        outlined></v-datetime-picker>
                                                </v-col>



                                                <!-- Description -->
                                                <v-col cols="12" sm="12" md="12">
                                                    <b>Description</b>
                                                    <v-text-field v-model="description" outlined></v-text-field>
                                                </v-col>



                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" :disabled="!isFormValid" @click="save">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog_edit" max-width="500px">
                            <v-card class="box">
                                <v-card-title class="toolbar">
                                    <span class="headline"> Edit Event</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <!-- Event Name -->
                                            <v-col cols="12" sm="12" md="12">
                                                <b>Event Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                <v-text-field v-model="editedItem.name"
                                                    :persistent-hint="editedIndex !== -1"
                                                    :rules="[v => !!v || 'Event Name is required']"
                                                    hint="For ex. PTM-Dec-2024..." outlined dense></v-text-field>
                                            </v-col>

                                            <!-- From Date -->

                                            <v-col cols="12" sm="12" md="12">
                                                <b>From Date</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                <v-datetime-picker v-model="editedItem.from_date_time"
                                                    dateFormat="dd-MM-yyyy" outlined></v-datetime-picker>
                                            </v-col>

                                            <!-- To Date -->
                                            <v-col cols="12" sm="12" md="12">
                                                <b>To Date</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                <v-datetime-picker v-model="editedItem.to_date_time" label="To Date"
                                                    dateFormat="dd-MM-yyyy" outlined></v-datetime-picker>
                                            </v-col>



                                            <!-- Description -->
                                            <v-col cols="12" sm="12" md="12">
                                                <b>Description</b>
                                                <v-text-field v-model="editedItem.description" outlined></v-text-field>
                                            </v-col>

                                            <!-- Active Checkbox -->
                                            <v-col cols="12" sm="6" md="4">
                                                <v-checkbox v-model="editedItem.isactive" color="success" label="Active"
                                                    dense></v-checkbox>
                                            </v-col>


                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <br>
                                <v-row justify="center">
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="edit()">Save</v-btn>
                                        <v-btn class="mb-2 button" text @click="dialog_edit = false">Close</v-btn>
                                    </v-card-actions>
                                </v-row>






                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <template v-slot:item.description="{ item }">
                    <div v-if="item.description">

                        <v-icon class=" v-icon-size" color="green" @click="descriptionopen(item)">mdi-eye</v-icon>

                    </div>
                    <div v-else>
                        --


                    </div>
                </template>
                <!-- <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template> -->
                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>

                </template>
                <template v-slot:item.delete="{ item }">
                    <div>
                        <v-avatar size="25" class="edit-avatar">
                            <v-icon class=" v-icon-size" color="red" @click="deleteItem(item)">mdi-trash-can</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
            <v-dialog v-model="dialogdescriptionopen" max-width="500px">

                <v-card>

                    <div class="pa-7 font-weight-bold">
                        {{ showdescription }}
                    </div>

                    <v-card-text>
                        <v-container>
                            <v-row>

                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mb-2 button" text @click="dialogdescriptionopen = false">Cancel</v-btn>

                    </v-card-actions>

                </v-card>
            </v-dialog>

            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import "@/assets/css/color.css";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datetime from "vuejs-datetimepicker";
import moment from "moment";
import axios from "axios";
export default {
    components: {
        Datepicker,
        datetime,
    },
    data: () => ({
        valid: false,
        overlay: false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        dialogdescriptionopen: false,
        search: "",
        dialog: false,
        dialog_edit: false,
        id: "",
        name: "",

        from_date_time: null,
        to_date_time: null,
        description: "",
        isactive: true,
        headers: [
            {
                text: "Name",
                align: "left",
                sortable: false,
                value: "name",
            },
            {
                text: "From Date And Time",
                align: "left",
                sortable: false,
                value: "from_date_time",
            },
            {
                text: "To Date And Time",
                align: "left",
                sortable: false,
                value: "to_date_time",
            },
            {
                text: "Instructor",
                align: "left",
                sortable: false,
                value: "inst_name",
            },
            {
                text: "Description",
                align: "left",
                sortable: false,
                value: "description",
            },
            {
                text: "Status",
                align: "left",
                sortable: true,
                value: "isactive",
            },


            { text: "Edit", value: "action", sortable: false },
            { text: "Delete", value: "delete", sortable: false },
        ],
        event_list: [],
        instructor_list: [],
        editedIndex: -1,
        editedItem: {
            id: "",
            name: "",

            from_date_time: null,
            to_date_time: null,
            description: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            name: "",

            from_date_time: "",
            to_date_time: "",
            description: "",
            isactive: true,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? "New Event"
                : "Edit Event";
        },
        isFormValid() {
            return this.name && this.from_date_time && this.to_date_time;
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        descriptionopen(item) {
            this.dialogdescriptionopen = true;
            this.showdescription = item.description;

        },
        toggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/Appointment/toggleEvent", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Event Status Changed!"); // show snackbar
                        this.onLoad();
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        deleteItem(item) {

            if (!confirm("Are You Sure You Want To Delete Event ...?")) return;
            const formData = {
                id: item.id,

            };

            axios
                .post("/Appointment/deleteEvent", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", "Event Delete Successfully..."); // show snackbar on success
                        //  this.payment_gateway_details_list = res.data.payment_gateway_details_list;

                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                ;
        },
        editItem(Item) {
            const data = {
                event_id: Item.id,
            };
            axios
                .post("/Appointment/getdatafromevent", data)
                .then((res) => {
                    if (res.data.flag === "Yes") {
                        this.editedItem = res.data.event_details[0];

                        // Replace 'PM' with 'PM' if necessary and remove seconds if they are included
                        const fromDateTimeString = this.editedItem.from_date_time.replace(' PM', ' PM'); // Adjust if necessary
                        const endDateTimeString = this.editedItem.end_date_time.replace(' PM', ' PM'); // Adjust if necessary

                        // Use moment to parse the dates with the appropriate format
                        const momentFromDate = moment(fromDateTimeString, 'YYYY-MM-DD hh:mm A');
                        const momentToDate = moment(endDateTimeString, 'YYYY-MM-DD hh:mm A');

                        // Check if moment returned valid dates
                        if (momentFromDate.isValid() && momentToDate.isValid()) {
                            this.editedItem.from_date_time = momentFromDate.toDate(); // Set the date object
                            this.editedItem.to_date_time = momentToDate.toDate(); // Set the date object
                        } else {
                            // Handle invalid date format, maybe log an error or set to null
                            console.error('Invalid date format:', fromDateTimeString, endDateTimeString);
                            this.editedItem.from_date_time = null;
                            this.editedItem.to_date_time = null;
                        }

                        this.dialog_edit = true;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        initializeErrorMsgFalse() {
            this.errorMsg.name = false;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/Appointment/getEvent")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.event_list = res.data.event_list;
                            this.instructor_list = res.data.instructor_list;
                        }
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            var from_date_time = moment(this.from_date_time).format("YYYY-MM-DD HH:mm")
            var to_date_time = moment(this.to_date_time).format("YYYY-MM-DD HH:mm")
            // Create event data object
            const eventData = {
                from_date_time: from_date_time,
                to_date_time: to_date_time,
                name: this.name,

                description: this.description,
                isactive: this.isactive,

            };

            // Send event data via Axios
            axios
                .post("/Appointment/saveEvent", eventData) // eventData, not this.eventData
                .then((res) => {
                    if (res.data.code === "SUCCESS") {
                        // On success: reload, add event to list, and show success message


                        this.showSnackbar("#4caf50", "Event Added Successfully..."); // Success snackbar

                        this.onLoad();
                        this.name = null;

                        this.description = "";
                    } else if (res.data.code === "NA") {
                        // Show error message if event already exists
                        this.showSnackbar("#b71c1c", "Event Already Present!!!");
                    }
                })
                .catch((error) => {
                    window.console.log(error); // Handle any errors during the request
                    this.name = null;

                    this.description = "";
                });

            // Close the event creation dialog or reset form
            this.close();


        },
        edit() {
            var from_date_time = moment(this.editedItem.from_date_time).format("YYYY-MM-DD HH:mm")
            var to_date_time = moment(this.editedItem.to_date_time).format("YYYY-MM-DD HH:mm")
            // Create event data object
            const data = {
                from_date_time: from_date_time,
                to_date_time: to_date_time,
                name: this.editedItem.name,

                description: this.editedItem.description,
                isactive: this.editedItem.isactive,
                id: this.editedItem.id,
            };
            // const data = {
            //     item: Item
            // };
            axios
                .post("/Appointment/editEvent", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        // Object.assign(
                        //     this.event_list[this.editedIndex],
                        //     this.editedItem
                        // );
                        this.onLoad();
                        this.dialog_edit = false;
                        this.showSnackbar(
                            "#4caf50",
                            "Event  Updated Successfully..."
                        ); // show snackbar on success
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });

            this.close();

        }
    }, // end of save()

    isValidated() {
        if (this.editedItem.name) {
            return true;
        } else {
            if (!this.editedItem.name) {
                this.errorMsg.name = true;
            }

            return false;
        }
    }, // .....end of isValidated()
};

</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>